import { useEffect, useState } from 'react'
import { learningApi } from '../services/api'

// True when the signed-in user may edit Learning content. Only the hub
// deployment answers GET /learning/admin/me; anywhere else it is 404 => false.
export default function useLearningEditor() {
  const [editor, setEditor] = useState(false)
  useEffect(() => {
    let cancelled = false
    learningApi.adminMe()
      .then((res) => { if (!cancelled) setEditor(Boolean(res?.data?.editor)) })
      .catch(() => { if (!cancelled) setEditor(false) })
    return () => { cancelled = true }
  }, [])
  return editor
}
